import {LeadList, LeadRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip, PersonAvatar, euros} from "../../../../components/kit";
import {Box, Stack, Typography} from "@mui/material";
import {LEAD_SOURCE, LEAD_STATUS} from "../labels";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED, COLOR_ROJO_CLARO} from "../../../../components/layout/colors";
import dayjs from "dayjs";

export const LeadListPage = () => {
    const apiManager = useApiManager();

    const isDue = (bean: LeadList) =>
        bean.nextActionDate != null && !dayjs(bean.nextActionDate).isAfter(dayjs(), "day");

    const listConfig: AppListConfig<LeadList> = {
        title: "Leads",
        onClick: "/app/admin/marketing/lead",
        headers: [
            {title: "Lead", width: "24%"},
            {title: "Organización"},
            {title: "Origen"},
            {title: "Estado"},
            {title: "Segmento"},
            {title: "Variante"},
            {title: "Toques", align: "right"},
            {title: "Próx. acción"},
        ],
        decorator: (bean: LeadList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    {/* Un lead puede no tener email desde #11395: las referencias de BNI llegan
                        con nombre y teléfono y nada más. Sin este respaldo, la columna que
                        identifica la fila saldría vacía justo para esos. */}
                    <Stack direction="row" spacing={1.5} alignItems="center" sx={{minWidth: 0}}>
                        <PersonAvatar name={bean.name || bean.email || ""} size={30}/>
                        <Box sx={{minWidth: 0}}>
                            <Typography variant="body2" fontWeight={600} noWrap>{bean.name || bean.email || bean.phone || "—"}</Typography>
                            {bean.name && (bean.email || bean.phone) &&
                                <Typography variant="caption" color="text.secondary" noWrap display="block">{bean.email ?? bean.phone}</Typography>}
                        </Box>
                    </Stack>
                </TableCell>
                <TableCell>{bean.organizationName ?? "-"}</TableCell>
                <TableCell>{bean.source ? (LEAD_SOURCE[bean.source] ?? bean.source) : "—"}</TableCell>
                <TableCell>{bean.status ? <SoftChip label={LEAD_STATUS[bean.status]?.label ?? bean.status} tone={LEAD_STATUS[bean.status]?.tone ?? "neutral"}/> : "—"}</TableCell>
                <TableCell>{bean.segment ?? "-"}</TableCell>
                <TableCell>{bean.abVariant ?? "-"}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>{bean.touchCount ?? "—"}</TableCell>
                <TableCell style={isDue(bean) ? {color: COLOR_ROJO_CLARO, fontWeight: "bold"} : {}}>
                    {bean.nextActionDate ? dayjs(bean.nextActionDate).format("DD/MM/YYYY") : "-"}
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(LeadRestControllerApiFactory);
            // Orden posicional: page, size, sort, status, source, touchDue, inOperation, maintainedBy,
            // referredById, term, showDismissed. Los dos `undefined` centrales son inOperation y
            // maintainedBy, que entraron en el filtro con #11788 y desplazaron a referredById —
            // ver la advertencia del README del cliente TS sobre XxxFilters y llamadas posicionales.
            return ctrl.pageLead(currentPage, size, undefined, undefined, undefined, undefined, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
